import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import winnerAnouncementModel from "@/models/lucky-draw/winner-anouncement";
import router from "@/router";
import store from "@/store";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import usePagination from "@/views/components/pagination/usePagination";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import useDate from "@/utils/hooks/useDate";
import {
  onBeforeMount,
  reactive,
  watch,
  ref,
  getCurrentInstance,
} from "@vue/composition-api";
// import Emoji from "quill-emoji";
// import "quill-emoji/dist/quill-emoji.css";
// import { Quill } from 'vue-quill-editor'

export default function useCampaignWinnerInfo() {
  const vm = getCurrentInstance().proxy;
  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    createCampaign,
    fetchCampaignList,
    fetchCampaignDetail,
    editCampaign,
    setCampaignStatus,
    setRoundStatus,
    createRound,
    editRound,
    deleteRound,
    fetchRoundDetail,
    fetchRoundList,
    editReward,
  } = winnerAnouncementModel();

  const {
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const { resolveDateWithSeperator } = useDate();

  const { openModal, closeModal } = useModal();

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr();

  const modalType = reactive({
    roundReward: false,
  });

  const formData = reactive({
    dataNull: "",
    seq: 0,
    id: 0,
    name: "",
    campaignNameTh: "",
    campaignNameEn: "",
    pointUsed: "",
    redeemable: "",
    issueOverall: "",
    issuePerMonth: "",
    issuePerDay: "",
    issuePerCustomer: "",
    issuePerCustomerMonth: "",
    issuePerCustomerDay: "",
    isHoverValidFrom: false,
    isHoverValidThrough: false,
    calValidFromDate: null,
    calValidThroughDate: null,
    status: false,
    mainImage: { file: null, url: null },
    subImage: { file: null, url: null },
    validFrom: {
      date: "",
      dt: "",
      time: "",
    },
    validThrough: {
      date: "",
      dt: "",
      time: "",
    },
    ruleTh: "",
    ruleEn: "",
  });

  const formRoundItem = reactive({
    campaignId: null,
    roundId: null,
    validFrom: {
      date: "",
      dt: "",
      time: "",
    },
    validThrough: {
      date: "",
      dt: "",
      time: "",
    },

    validFromModal: {
      date: "",
      time: "",
    },
    validThroughModal: {
      date: "",
      time: "",
    },
  });

  const fields = [
    { key: "seq", label: "No" },
    { key: "round_name_th", label: "Round Name" },
    { key: "created_by", label: "Created By" },
    { key: "valid_form", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const loading = reactive({
    tableData: false,
  });

  const roundListTable = reactive({
    payload: [],
  });

  const LuckyDrawActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "IconEditWinner",
      display: true,
    },

    delete: {
      label: "Delete",
      value: 7,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        openRoundAndRewardModal(item.item.round, true);
        return;

      case 7:
        onRemoveRound(item.item.round);
      default:
    }
  };

  const isEdit = ref(false);
  const isEditRound = ref(false);

  const fetchCampaignInfoFunc = () => {
    window.$loading(true);
    fetchCampaignDetail.payload.CampaignId = parseInt(formData.id);

    store
      .dispatch("api/apiRequest", fetchCampaignDetail)
      .then((response) => {
        const respData = response.data.resp;
        if (Object.keys(respData).length > 0) {
          formData.id = respData.campaign.campaignid;
          formData.campaignNameTh = respData.campaign.name_th;
          formData.campaignNameEn = respData.campaign.name_en;
          formData.validFrom.dt = respData.campaign.valid_form;
          formData.validThrough.dt = respData.campaign.valid_through;
          formData.validFrom.date = resolveDate(respData.campaign.valid_form);
          formData.validFrom.time = resolveTime(respData.campaign.valid_form);
          formData.validThrough.date = resolveDate(
            respData.campaign.valid_through
          );
          formData.validThrough.time = resolveTime(
            respData.campaign.valid_through
          );
          formData.status = respData.campaign.status == 1;
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetchRoundListFunc = () => {
    loading.tableData = true;
    fetchRoundList.payload.CampaignId = parseInt(formData.id);
    fetchRoundList.payload.Page = pagination.currentPage;
    fetchRoundList.payload.Limit = pagination.perPage;
    fetchRoundList.payload.Filters = filters;
    fetchRoundList.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchRoundList)
      .then((response) => {
        if (response.status == "success") {
          const respData = response.data.payload;
          roundListTable.payload = respData;
          pagination.rows = response.data.payload.length;
          pagination.totalRows =
            response.data.total_record ?? response.data.payload.length;
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const onRemoveRound = (item) => {
    openWarningModal(
      "ลบ Round",
      `ต้องการลบรายการ ${item.round_name_th ? item.round_name_th : item.round_id
      } นี้หรือไม่ ?`,
      () => {
        deleteRound.payload.RoundId = item.round_id;

        store
          .dispatch("api/apiRequest", deleteRound)
          .then((response) => {
            openSuccessModal(
              "ลบรายการสำเร็จ !",
              null,
              "ตกลง",
              () => {
                fetchRoundListFunc();
              },
              () => { }
            );
          })
          .catch((error) => {
            openErrorModal(error.statusText);
          })
          .finally(() => { });
      }
    );
  };

  const checkFormCreateOrEdit = () => {
    isEdit.value = false;
    if (router.currentRoute.params.campaignId) {
      isEdit.value = true;
      formData.id = router.currentRoute.params.campaignId;
    }
  };

  const resolveDateFormat = (dateStr) => {
    if (!dateStr) return;
    const dateSplit = dateStr.split("-");
    const date = dateSplit[0];
    const month = dateSplit[1];
    const year = dateSplit[2];

    return `${year}-${month}-${date}`;
  };

  const onSubmitForm = () => {
    window.$loading(true);
    const payload = {
      CampaignId: null,
      Name_TH: "",
      Name_EN: "",
      Valid_Form: null,
      Valid_Through: null,
      Status: null,
    };

    createCampaign.payload = payload;
    editCampaign.payload = payload;

    let payloadParam = {};
    if (formData.id || isEdit.value) {
      payloadParam = editCampaign;
      payloadParam.payload.CampaignId = formData.id;
      payloadParam.payload.Name_TH = formData.campaignNameTh;
      payloadParam.payload.Name_EN = formData.campaignNameEn;
      payloadParam.payload.Valid_Form =
        formData.validFrom.date && formData.validFrom.time
          ? `${resolveDateFormat(formData.validFrom.date)} ${formData.validFrom.time
          }`
          : null;
      payloadParam.payload.Valid_Through =
        formData.validThrough.date && formData.validThrough.time
          ? `${resolveDateFormat(formData.validThrough.date)} ${formData.validThrough.time
          }`
          : null;
      payloadParam.payload.Status = formData.status == true ? 1 : 2;
    } else {
      payloadParam = createCampaign;
      payloadParam.payload.Name_TH = formData.campaignNameTh;
      payloadParam.payload.Name_EN = formData.campaignNameEn;
      payloadParam.payload.Valid_Form =
        formData.validFrom.date && formData.validFrom.time
          ? `${resolveDateFormat(formData.validFrom.date)} ${formData.validFrom.time
          }`
          : null;
      payloadParam.payload.Valid_Through =
        formData.validThrough.date && formData.validThrough.time
          ? `${resolveDateFormat(formData.validThrough.date)} ${formData.validThrough.time
          }`
          : null;
      payloadParam.payload.Status = formData.status == true ? 1 : 2;
    }
    store
      .dispatch("api/apiRequest", payloadParam)
      .then((response) => {
        if (response.status == "success") {
          openSuccessModal("ทำรายการสำเร็จ !", null, null, null, () => {
            formData.id = response.data.campaign.campaignid;
            router.replace(`/lucky-draw/campaign/infoWinner/${formData.id}`);
          });
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onUploadMainImg = (image) => {
    formData.mainImage.file = image.file;
    formData.mainImage.url = image.url;
  };

  const onUploadSubImg = (image) => {
    formData.subImage.file = image.file;
    formData.subImage.url = image.url;
  };

  const onNumberInput = (ev, formDataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "");
      formData[formDataValue] = inputNumber;
    });
  };

  const openRoundAndRewardModal = (roundItem, isEdit = false) => {
    isEditRound.value = false;

    if (isEdit == true || roundItem.round_id) {
      isEditRound.value = true;
      formRoundItem.roundId = roundItem.round_id;
      formRoundItem.validFrom.dt = formData.validFrom.dt;
      formRoundItem.validThrough.dt = formData.validThrough.dt;
      formRoundItem.validFrom.date = formData.validFrom.date;
      formRoundItem.validFrom.time = formData.validFrom.time;
      formRoundItem.validThrough.date = formData.validThrough.date;
      formRoundItem.validThrough.time = formData.validThrough.time;
      modalType.roundReward = true;
      openModal();
    } else {
      onCreateRound();
    }
  };

  const onCloseModalRound = () => {
    modalType.roundReward = false;
    closeModal();
  };

  const onCreateRound = () => {
    window.$loading(true);
    createRound.payload.CampaignId = formData.id;

    store
      .dispatch("api/apiRequest", createRound)
      .then((response) => {
        const resp = response.data.resp;
        formRoundItem.roundId = resp.round.round_id;
        formRoundItem.campaignId = formData.id;
        formRoundItem.validFrom.date = formData.validFrom.date;
        formRoundItem.validThrough.date = formData.validThrough.date;
        formRoundItem.validFrom.time = formData.validFrom.time;
        formRoundItem.validThrough.time = formData.validThrough.time;
        formRoundItem.validFrom.dt = formData.validFrom.dt;
        formRoundItem.validThrough.dt = formData.validThrough.dt;
        modalType.roundReward = true;
        openModal();
        fetchRoundListFunc();
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onSubmitRoundReward = (form) => {
    onUpdateRound(form).then((rep) => {
      onUpdateReward(form);
    });
  };

  const onUpdateRound = (form) => {
    return new Promise((resolve, reject) => {
      window.$loading(true);
      const payload = {
        CampaignId: formData.id,
        RoundId: form.round.roundId,
        Round_Name_TH: form.round.nameTh,
        Round_Name_EN: form.round.nameEn,
        Valid_Form:
          form.validFrom.date && form.validFrom.time
            ? `${resolveDateFormat(form.validFrom.date)} ${form.validFrom.time}`
            : null,
        Valid_Through:
          form.validThrough.date && form.validThrough.time
            ? `${resolveDateFormat(form.validThrough.date)} ${form.validThrough.time
            }`
            : null,
        Status: form.round.status == true ? 1 : 2,
      };

      editRound.payload = payload;

      store
        .dispatch("api/apiRequest", editRound)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          openDefaultErrorModal(error);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const onUpdateReward = (form) => {
    window.$loading(true);
    const payload = {
      RoundId: form.round.roundId,
      Rewards: form.rewardItem.payload.map((e) => ({
        RewardId: e.id,
        Title: e.title,
        Reward_Name: e.name,
        Image: e.file,
        Image_URL: e.url,
        Reward_Value: e.value || 0,
        Status: e.status == true ? 1 : 2,
        IsDisplay_Winner: e.isdisplay_winner,
      })),
    };
    editReward.payload = payload;
    store
      .dispatch("api/apiFormRequest", editReward)
      .then((response) => {
        openSuccessModal("ทำรายการสำเร็จ !", null, null, null, () => {
          onCloseModalRound();
          fetchRoundListFunc();
        });
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onToggleStatus = (status, round) => {
    loading.tableData = true;
    setRoundStatus.payload.RoundId = round.round_id;
    setRoundStatus.payload.Status = status ? 1 : 2;
    store
      .dispatch("api/apiRequest", setRoundStatus)
      .then((response) => {
        fetchCampaignInfoFunc();
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchRoundListFunc();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchRoundListFunc();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    checkFormCreateOrEdit();
    if (formData.id) {
      fetchCampaignInfoFunc();
      fetchRoundListFunc();
    }
  });

  return {
    formData,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onSubmitForm,
    onUploadMainImg,
    onUploadSubImg,
    onNumberInput,
    loading,
    roundListTable,
    fields,
    LuckyDrawActionList,
    resolveMappingTableAction,
    pagination,
    onPageChange,
    onFilterEntity,
    openRoundAndRewardModal,
    modalType,
    onCloseModalRound,
    isEdit,
    formRoundItem,
    isEditRound,
    onSubmitRoundReward,
    onToggleStatus,
    resolveDateWithSeperator,
    resolveDate,
    resolveTime,
    // customQuillOption
  };
}
